import { useMemo } from 'react'

import { canUseWindow } from '@library/environment'

import { DEFAULT_BOXES, TAPERED_DISCOUNT_BOXES, TAPERED_PROMO_CODE } from '../config/discountBoxes'

export const usePaidSearchBrandDiscountBoxes = () =>
  useMemo(() => {
    if (!canUseWindow()) {
      return DEFAULT_BOXES
    }

    const promoCode = new URLSearchParams(window.location.search).get('promo_code')

    return promoCode?.toUpperCase() === TAPERED_PROMO_CODE ? TAPERED_DISCOUNT_BOXES : DEFAULT_BOXES
  }, [])
